import React, { useState } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { fontBold, fontRegular, fontSemiBold } from "../../../utils/fontFamily"
import {
  megaMenuTheme,
  borderTheme,
  headlineTextTheme,
  brandAccentColor,
  brandSecondaryColor,
} from "../../../theme"
import H4 from "../../typography/H4"
import useLockBodyScroll from "../../../utils/hooks/useLockBodyScroll"
import MenuOpenGraphic from "../../../images/menu-open.svg"
import MenuClosedGraphic from "../../../images/menu-closed.svg"
import { useTheme } from "../../../context/ThemeContext"
import { StandardPlanName } from "../../../utils/enumUtil"
import config from "../../../config/config"

const MobileMenu = ({ stickySubNav }) => {
  const themeToggle = useTheme()
  const [MobileMenuPopupOpen, setMobileMenuPopupOpen] = useState(false)

  const handleMobileMenuToggle = () => {
    setMobileMenuPopupOpen(!MobileMenuPopupOpen)
  }

  const onTrialClick = () => {
    themeToggle.saveTrialPlan(StandardPlanName.Premium)
  }
  return (
    <>
      <MobileMenuToggle
        onClick={handleMobileMenuToggle}
        className={MobileMenuPopupOpen ? "menu-open" : "menu-closed"}
      >
        {MobileMenuPopupOpen ? (
          <img src={MenuClosedGraphic} />
        ) : (
          <img src={MenuOpenGraphic} />
        )}
      </MobileMenuToggle>
      {MobileMenuPopupOpen && (
        <MobileMenuPopup
          onTrialClick={onTrialClick}
          mobileMenuPopupOpen={MobileMenuPopupOpen}
        />
      )}
    </>
  )
}

const MobileMenuPopup = ({ mobileMenuPopupOpen, onTrialClick }) => {
  useLockBodyScroll()
  return (
    <MobileMenuPopupBg className={mobileMenuPopupOpen ? "reveal" : ""}>
      <MobileMenuHeaders>Choose a Plan</MobileMenuHeaders>
      <hr />
      <MobileMenuNav>
        <MobileMenuNavItem>
          <Link to={"/pricing"}>Pricing</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem onClick={() => onTrialClick()}>
          Free Trial
        </MobileMenuNavItem>
      </MobileMenuNav>
      <MobileMenuHeaders>Platform</MobileMenuHeaders>
      <hr />
      <MobileMenuNav>
        <MobileMenuNavItem>
          <Link to="/platform/salesfunnel/">Sales Funnel</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/platform/campaigns/">Text & Email Campaigns</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/platform/contact-management/">Contact Management</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/platform/mobile-landing-pages/">Mobile Landing Pages</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/platform/automation/">Advanced Automation</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/platform/payments-billing/">Payments & Billing</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/platform/offers/">Digital Offers</Link>
        </MobileMenuNavItem>
      </MobileMenuNav>
      <MobileMenuHeaders>Features</MobileMenuHeaders>
      <hr />
      <MobileMenuNav>
        <MobileMenuNavItem>
          <Link to="/features/intelligent-delivery/">Intelligent Delivery</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/features/custom-domains/">Custom Domains</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/features/smartlists-and-filters/">
            Smart Lists & Filters
          </Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/features/library/">Resource Library</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/features/reporting/">Reporting</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="/features/actions/">Actions</Link>
        </MobileMenuNavItem>
      </MobileMenuNav>
      <MobileMenuHeaders>Resources</MobileMenuHeaders>
      <hr />
      <MobileMenuNav>
        <MobileMenuNavItem>
          <Link to="/resources/tour/">Take a Tour</Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="https://knowledgebase.mindmemobile.com" target="_blank">
            Knowledgebase
          </Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link
            to="https://knowledgebase.mindmemobile.com/videos"
            target="_blank"
          >
            Videos
          </Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link to="https://blog.mindmemobile.com" target="_blank">
            Blog
          </Link>
        </MobileMenuNavItem>
      </MobileMenuNav>
      <MobileMenuHeaders>Info</MobileMenuHeaders>
      <hr />
      <MobileMenuNav>
        {/* <MobileMenuNavItem>
          <Link
            to="https://meetings.hubspot.com/bert/mindme-demo"
            target="_blank"
          >
            Schedule Demo
          </Link>
        </MobileMenuNavItem> */}
        <MobileMenuNavItem>
          <Link to="/support/">Get Support</Link>
        </MobileMenuNavItem>
      </MobileMenuNav>
      <MobileMenuHeaders>Access</MobileMenuHeaders>
      <hr />
      <MobileMenuNav>
        <MobileMenuNavItem>
          <Link to={`${config.WEB_ENDPOINT}login`} target="_blank">
            Account Login
          </Link>
        </MobileMenuNavItem>
        <MobileMenuNavItem>
          <Link
            to={`${config.AFFILIATE_WEB_ENDPOINT}affiliate/login`}
            target="_blank"
          >
            Affiliate Login
          </Link>
        </MobileMenuNavItem>
      </MobileMenuNav>
    </MobileMenuPopupBg>
  )
}

export default MobileMenu

const MobileMenuToggle = styled.button`
  ${({ theme }) => theme.se`
    display: flex;
    appearance: none;
    background: none;
    border: none;
    height: 50px;
    width: 50px;

    img {
      margin-bottom: 0;
      width: 100%;
      height: 100%;
    }

    &.menu-closed {
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-end;
      transition: all 200ms linear;

      span {
        transition: all 200ms linear;
        transform: rotate(0deg);
      }
    }

    &.menu-open {
      display: inline-block;
      flex-direction: unset;
      justify-content: unset;
      align-items: unset;
      transition: all 200ms linear;

      span {
        transition: all 200ms linear;
        transform: rotate(45deg);
      }

      span:last-child {
        transition: all 200ms linear;
        transform: rotate(-45deg);
        width: 100%;
        margin-left: 0px;
        margin-top: -4px;
      }
    }

    > span {
      display: block;
      width: 100%;
      background: #777;
      height: 5px;
      border-radius: 50px;

      &:last-child {
        width: 60%;
      }
    }
  `}

  ${({ theme }) => theme.desktop`
    display: none;

    &.menu-closed {
      display: none;
    }

    &.menu-open {
      display: none;
    }
  `}
`

const MobileMenuPopupBg = styled.div`
  display: none;
  margin: 0;
  width: 100%;
  background-color: #f4f4f4;
  position: absolute;
  z-index: 10;
  left: 0;
  top: 66px;
  padding: 20px;

  &.reveal {
    /* display: flex;
    flex-direction: column; */
    display: block;
    overflow-y: scroll;
    height: 100vh;
    padding-bottom: 170px;
  }

  ${({ theme }) => theme.desktop`
    display: none;

    &.reveal {
      display: none;
    }
  `}
`

const MobileMenuNav = styled.ul`
  ${fontSemiBold()};
  margin-left: 0;
  margin-bottom: 50px;
`

const MobileMenuNavItem = styled.li`
  list-style: none;
  a {
    color: #555;
    text-decoration: none;
  }
`

const MobileMenuHeaders = styled(H4)`
  ${({ theme }) => theme.se`
    font-size: 14px;
    margin-bottom: 15px;
    color: ${brandSecondaryColor};
    ${fontBold()};
  `}
`
